import styled from 'styled-components';

// Sub-line under an identifier in the transport tables (profile, EUDR).
// PLA-971: replaces the inline styles that were duplicated across
// InventoryItem and UnloadItem.
const IdentifierSub = styled.div`
  font-size: 0.85rem;
  color: #6b6b6b;
`;

export default IdentifierSub;
